<template>
  <span>
    <strong v-if="type === 'TRACKING_GROUP'" class="tgCode">(TG)</strong>
    <strong v-else-if="type === 'CLIENT_ID'" class="clientCode">(C)</strong>
    <strong v-else-if="type === 'GROUP'" class="gCode">(G)</strong>
    <strong v-else-if="type === 'PARENT'" class="pCode">(P:{{ value2 }})</strong>
    <strong v-else-if="type === 'ALL_TRACKING_GROUPS'">All Groups Included</strong>
    <strong v-else>({{ type }})</strong>
  </span>
</template>
<script>
export default {
  name: 'group-track-client',
  props: {
    type: String,
    value2: String
  }
}
</script>
<style lang="scss" scoped>
.clientCode {
  color: #004B98;
}
.tgCode {
  color: #00A9E0;
}
.gCode {
  color: #E0640E;
}
.pCode {
  color: #4004FE;
}
</style>
